import { render, staticRenderFns } from "./ProfilePictureAlertDialog.vue?vue&type=template&id=17311d60&"
import script from "./ProfilePictureAlertDialog.vue?vue&type=script&lang=js&"
export * from "./ProfilePictureAlertDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
